import { Controller } from "stimulus";

// The add-party modal renders one pre-filtered address select per role rather
// than one select whose options are rewritten as the role changes: select2
// keeps its own copy of the option list and does not reliably notice DOM
// rewrites (three past attempts left the list empty). Showing and hiding whole
// selects never touches select2's options, so it cannot hit that bug.
//
// The role select is a select2 too, so the change is bound with jQuery rather
// than a Stimulus data-action: select2 fires its change through jQuery, and a
// jQuery-triggered event never reaches a native addEventListener — which is
// what data-action registers. Binding with jQuery catches both.
//
// address-select is attached here rather than in the markup. select2 measures
// the element when it initialises, and one inside a hidden container measures
// zero — the widget renders but is invisible. Attaching the controller only
// once the select is on screen means it is always measured visible; removing it
// again runs address-select's disconnect, which destroys the select2 instance.
//
// Exactly one address select is enabled at a time; the rest are disabled so
// they do not submit. Switching role clears the previous choice — it belonged
// to the other role's address book.
export default class extends Controller {
  static targets = ["role", "book", "hint"];

  connect() {
    this.applyRole = this.applyRole.bind(this);
    $(this.roleTarget).on("change", this.applyRole);
    this.applyRole();
  }

  disconnect() {
    $(this.roleTarget).off("change", this.applyRole);
  }

  applyRole() {
    const roleId = this.roleTarget.value;

    this.bookTargets.forEach((book) => {
      const matches = book.dataset.roleId === roleId;
      book.classList.toggle("d-none", !matches);

      const select = book.querySelector("select");
      if (!select) return;

      select.disabled = !matches;

      if (matches) {
        select.setAttribute("data-controller", "address-select");
      } else {
        select.removeAttribute("data-controller");
        select.value = "";
      }
    });

    if (this.hasHintTarget) this.hintTarget.classList.toggle("d-none", Boolean(roleId));
  }
}
